$(document).ready(function() {
	if(!document.querySelector('.service-network')) return false;

	 var network = function(){

		var common = $(".service-network");
		var countryList = common.find(".country-list");
		var countryToggle = countryList.find(".btn-continent-toggle");
		var id = $("html").data("continent");
		var countryLink = countryList.find(".country-content a").not(".language-tooltip a");
		var tooltipBtn = $(".tooltip-btn");

		function contentToggle(id, flag) {
			var content = $("#"+id).find(".country-content");
			var continent = id;
			var li = $("#"+continent);

			if (content.is(":animated")) {
				return;
			}       

			if(!li.hasClass("active")){
				countryList.find(">ul>li").removeClass("active").find(".country-content").stop().slideUp('fast');
				countryList.find(">ul>li").find(".btn-continent-toggle i").remove();
				countryList.find(">ul>li").find(".btn-continent-toggle").append("<i class='icon icon-pagenav-down'></i>");
				li.addClass("active");
				li.find(".btn-continent-toggle i.icon-pagenav-down").remove();
				li.find(".btn-continent-toggle").append("<i class='icon icon-pagenav-up'></i>");
				content.stop().slideDown('fast', function(){
					if (!flag) {
						contentScrollTop(continent);
					}
				});
			}else{
				li.removeClass("active");
				li.find(".btn-continent-toggle i").remove();
				li.find(".btn-continent-toggle").append("<i class='icon icon-pagenav-down'></i>");
				content.stop().slideUp('fast');
			}
		}

		function contentScrollTop(target){
			var pos = Math.floor(countryList.find('> ul > li#' + target +' > a').offset().top);
			$('html, body').stop().animate({ scrollTop : pos}, 500);
		}

		function openTooltip($btn){
			var box = $btn.parent();
			var tooltipBox = $btn.siblings(".language-tooltip");
			var firstItem = tooltipBox.find("a").filter(":first");
			var lastItem = tooltipBox.find("a").filter(":last");

			if($(".language-tooltip").hasClass("active"))
			$(".language-tooltip").removeClass("active");

			tooltipBox.addClass("active");

			lastItem.on("focusout", function(e) {
				e.preventDefault();
				tooltipBox.removeClass("active");
			});

			box.on("mouseleave", function(e){
				e.preventDefault();
				tooltipBox.removeClass("active");
			});
		}

		countryLink.on("focusin", function(e){
			e.preventDefault();
			var $this = $(this);
			if( !$this.siblings(".language-tooltip").is() && $(".language-tooltip").hasClass("active")) {
				$(".language-tooltip").removeClass("active");
			}
		});

		tooltipBtn.on("mouseenter focusin", function(e){
			e.preventDefault();
			var $this = $(this);
			openTooltip($this);
		});

		countryToggle.on("click.country", function(e){
			e.preventDefault();
			var $this = $(this),
				parent = $this.parent(),
				id = parent.attr("id");
			contentToggle(id);
			$('#us-map').find('area[data-region="' + id +'"]').trigger('click', [true]);
		});

		if(typeof(id) != 'undefined' && id != ""){
			contentToggle(id);
		}else{
			contentToggle('asia', true);
		}

		//img map
		if ($('img[usemap]').length > 0) {
			$('img[usemap]').rwdImageMaps();
		}

		if($('#us-map').length > 0) {
			var t, p;
			$('#us-map').find('area').on('click', function(e, flag) {
				e.preventDefault();
				var $this = $(this);
				var region = $this.data('region');
				p = $this.parents('.map-info');
				t = p.find('.region');
				var v = p.next('.column').find(':visible').data('region');
				t.each(function() {
					if($(this).data('region') == region) {
						$(this).show();
					}else{
						$(this).hide();
					}
				});
				if (!flag) {
					countryList.find('> ul > li#' + region +' > a').trigger('click.country');
				}
			});
		}
	};
	network();
});